import { switchMap } from 'rxjs/operators';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    Input,
    OnInit,
    QueryList,
} from '@angular/core';
import { MobileService } from '@klickdata/core/mobile/src/mobile.service';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { AuthService } from '@klickdata/core/auth';
import { IfStmt } from '@angular/compiler';

@Component({
    selector: 'app-menu-group',
    templateUrl: './menu-group.component.html',
    styleUrls: ['./menu-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuGroupComponent implements OnInit {
    @Input()
    public title: string;

    @ContentChildren(MenuItemComponent)
    items: QueryList<MenuItemComponent>;

    public open = true;

    constructor(protected mobile: MobileService, protected changeRef: ChangeDetectorRef, protected auth: AuthService) {}

    ngOnInit() {
        this.mobile
            .showingMenu()
            .pipe(switchMap(() => this.auth.getNK3Platform()))
            .subscribe((platform) => {
                if (platform !== 'user') {
                    this.open = false;
                }
                this.changeRef.markForCheck();

                if (this.items) {
                    this.items.forEach((item: MenuItemComponent) => {
                        if (item.isActive()) {
                            this.open = true;
                            this.changeRef.markForCheck();
                        }
                    });
                }
            });
    }

    public onOpen(): void {
        this.open = true;
    }

    public onClose(): void {
        this.open = false;
    }
}
